import { render, staticRenderFns } from "./betslip.vue?vue&type=template&id=3b2fd670&"
import script from "./betslip.vue?vue&type=script&lang=js&"
export * from "./betslip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports